import {AktionTypeEnum} from "../../../models/api/insight/AktionTypeEnum";
import type {Insight} from "../../../models/api/insight/Insight";
import {InsightTypeEnum} from "../../../models/api/insight/InsightTypeEnum";
import {KategorieEnum} from "../../../models/api/insight/KategorieEnum";
import {LizenzEnum} from "../../../models/api/insight/LizenzEnum";

const insights: Array<Insight> = [
    {
        id: "20260213-workflows",
        datum: "13.02.2026",
        kategorie: KategorieEnum.DESKTOP,
        type: InsightTypeEnum.FEATURE,
        title: "HiOrg-Workflows startet ins Beta-Programm",
        lizenz: [LizenzEnum.PRO],
        content: [
            "Mit HiOrg-Workflows entwickeln wir ein neues Modul für digitale Checklisten direkt in HiOrg-Server."
            + " Statt Papier, Zuruf und nachträglicher Dokumentation könnt ihr Abläufe strukturiert digital abarbeiten"
            + " – mobil und nachvollziehbar.",
            "Wenn du regelmäßig mit Checklisten arbeitest, egal ob als Admin, Disponent oder im operativen Dienst,"
            + " freuen wir uns über deine Teilnahme. In der Beta testest du digitale Checklisten im echten"
            + " Organisationsalltag und gibst Feedback zur Weiterentwicklung des Moduls.\n"
            + "Im ersten Schritt vergeben wir 50 Plätze.",
        ],
        aktions: [
            {
                type: AktionTypeEnum.LINK,
                text: "Jetzt für den Workflows-Beta-Test eintragen",
                url: "https://waitlist.hiorg-server.de/workflows-beta?utm_source=insights",
            },
            {
                type: AktionTypeEnum.BLOG,
                text: "Details im Blog",
                url: "https://info.hiorg-server.de/2026/02/hiorg-workflows-startet-ins-beta-programm/",
            },
        ],
    },
];

export {
    insights,
};
